/**
 * Results from a personal number credit check.
 */
export default class CreditCheckResult {
  ssn: string;
  credibility: Credibility | null = null;
  firstName: string;
  lastName: string;
  street?: string = '';
  zip?: string = '';
  city?: string = '';
  date?: Date;
  /**
   * Orten där avtalet signeras.
   */
  signCity: string = '';
  status: string = null;

  constructor(deriveFrom?: Partial<CreditCheckResult>) {
    if (!deriveFrom) {
      return;
    }

    Object.assign(this, deriveFrom);
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }

  /**
   * Name of this person, as it should appear on automatically signed agreements. 
   */
  get signee() {
    return `${this.firstName} ${this.lastName.substr(0, 1)}`;
  }

  get address() {
    if (!this.street) {
      return `${this.zip || ''} ${this.city || ''}`.trim();
    }

    return `${this.street || ''}, ${this.zip || ''} ${this.city || ''}`.trim();
  }
}

export type Credibility = "1" | "2" | "4";